import * as React from "react";
import { Link } from "react-router-dom";
import { Thumbnail } from "@components/molecules";
import { generateProductUrl } from "../../../core/utils";

var ProductItem = function ProductItem(_ref) {
  var _product$category;

  var product = _ref.node;
  return React.createElement("li", {
    className: "search__products__item"
  }, React.createElement(Link, {
    to: generateProductUrl(product.id, product.name)
  }, React.createElement(Thumbnail, {
    source: product
  }), React.createElement("span", null, React.createElement("h4", null, product.name), React.createElement("p", null, ((_product$category = product.category) === null || _product$category === void 0 ? void 0 : _product$category.name) || "-"))));
};

export default ProductItem;